/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeInt32NullableCombinableCriteria } from './EListSearchTypeInt32NullableCombinableCriteria';
import {
    EListSearchTypeInt32NullableCombinableCriteriaFromJSON,
    EListSearchTypeInt32NullableCombinableCriteriaFromJSONTyped,
    EListSearchTypeInt32NullableCombinableCriteriaToJSON,
} from './EListSearchTypeInt32NullableCombinableCriteria';

/**
 * 
 * @export
 * @interface Int32NullableListSearch
 */
export interface Int32NullableListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeInt32NullableCombinableCriteria>}
     * @memberof Int32NullableListSearch
     */
    criterias?: Array<EListSearchTypeInt32NullableCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof Int32NullableListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {number}
     * @memberof Int32NullableListSearch
     * @deprecated
     */
    value?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Int32NullableListSearch
     * @deprecated
     */
    secondaryValue?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Int32NullableListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof Int32NullableListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the Int32NullableListSearch interface.
 */
export function instanceOfInt32NullableListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Int32NullableListSearchFromJSON(json: any): Int32NullableListSearch {
    return Int32NullableListSearchFromJSONTyped(json, false);
}

export function Int32NullableListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32NullableListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeInt32NullableCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function Int32NullableListSearchToJSON(value?: Int32NullableListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeInt32NullableCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
        'defaultSearchType': value.defaultSearchType,
    };
}

